import { useQuery } from '@apollo/client';
import { useNotifications } from '@risksmart-app/components/src/notifications/useNotifications';
import { GetDocumentsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetPolicyRegister as useGetPolicyRegisterTRPC } from './useGetPolicyRegisterTRPC';
export const useGetPolicyRegister = (skip?: boolean) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const { addNotification } = useNotifications();

  const {
    data: graphqlData,
    loading: graphqlLoading,
    refetch: graphqlRefetch,
  } = useQuery(GetDocumentsDocument, {
    fetchPolicy: 'no-cache',
    skip: trpcEnabled || skip, // Skip GraphQL query when TRPC is enabled
    onError: (error) => {
      if (!trpcEnabled) {
        addNotification({
          type: 'error',
          content: <>{error.message}</>,
        });
      }
    },
  });

  const {
    data: trpcData,
    loading: trpcLoading,
    refetch: trpcRefetch,
  } = useGetPolicyRegisterTRPC(skip);

  // Return appropriate data based on feature flag
  if (trpcEnabled) {
    return {
      loading: trpcLoading,
      data: trpcData,
      refetch: () => trpcRefetch(),
    };
  }

  return {
    loading: graphqlLoading,
    data: graphqlData,
    refetch: () => graphqlRefetch(),
  };
};
